import React, { useEffect, useState } from "react";
import { rateContest } from "../../../redux/contest/action";
import { useDispatch } from "react-redux";


export default function CustomRating({ posts, rating, values }) {
  const [loading, setLoading] = useState(false);
  const [giverating, setGiverating] = useState(rating || 0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (values) {
      setGiverating(values?.rating || 0);
    }
  }, [values]);

  const ratethisContest = (id) => {
    if (posts.is_mine == 1) {
      setGiverating(id);
      const data = {
        proposal_id: values.id,
        type: 1,
        rating: id,
        comment: "Super Work",
        post_id: posts?.id,
      };
      dispatch(rateContest(data, setLoading));
    }
    else {
      return null
    }

  };

  const starStyle = {
    fontSize: "24px",
    color: "#d3d3d3",
  };

  const activeStarStyle = {
    color: "#ffcc00",
  };

  return (
    <>
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <i
            className={`fa-solid fa-star`}
            style={{
              ...starStyle,
              ...(star < rating ? activeStarStyle : {}),
            }}
            aria-hidden="true"
            onClick={() => ratethisContest(star)}
          ></i>
        ))}
      </div>
    </>
  );
}
